export enum EProviderImportStep {
  SELECT_PROVIDER = 'SELECT_PROVIDER',
  AUTHENTICATE = 'AUTHENTICATE',
  CONNECTING = 'CONNECTING',
  SAVING = 'SAVING',
  SELECT_POSITIONS = 'SELECT_POSITIONS',
  FAILED = 'FAILED',
  MAINTENANCE = 'MAINTENANCE'
}
